import _ from "lodash";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import cn from "classnames";
import UserInfo from "./components/user-info";
import { getCurrentDateAsQueryString } from "./currentDate";
import { isFreeUser } from "./user";
import { connect } from "react-redux";
import { hasAuth } from "./services/api";

const q = (s) => () => `${s}?${getCurrentDateAsQueryString()}`;

//List of routes by columns
const menuColumns = [
  [
     { path: "/search?fromMenu=1", className: "find", text: "Find" },
    {
      className: "gifts",
      text: "Giftcard",
    },
    { type: "delimiter" },
    { path: "/news/3", className: "sub-news", text: "Subscriber News" },
    { path: "album?id=X", className: "aow", text: "Album of the Week" },
    { path: "/info-card?track=X", className: "sod", text: "Song of the Day" },
  ],
  [
   
    { path: "/welcome", className: "home", text: "Home" },
     { type: "delimiter" },
    { path: "/drawer?position=0", className: "file-cabinet", text: "Recordings" },
    { path: "/outtakes?position=0", className: "outtakes-cabinet", text: "Outtakes" },
    { path: "/friends-and-family?position=0", className: "outtakes-cabinet", text: "Friends & Family" },
    { path: "/playlists?position=0", className: "playlist", text: "Playlists" },


    { type: "delimiter" },
        { path: q("/timeline-basic"), className: "timeline", text: "Timeline" },
          { path: "/news", className: "news", text: "NYA Times-Contrarian" },

    {
      path: "/movie-night/home",
      className: "movie-night-image",
      text: "Hearse Theater",
    },
        {
      path: "/movie-night/movietone",
      className: "pay-per-view-menu",
      text: "Movietone",
    },
  
    { type: "delimiter" },
    { url: "https://neilyoung.warnerrecords.com", className: "greedy-store", text: "Greedy Hand Store" },
    { url: "https://store.neilyoungarchives.com", className: "hi-res-store", text: "NYA Download Store" },
  ],
  [
    { type: "delimiter" },
    { path: "/account?screen=tickets", className: "tickets", text: "Tickets" },
    { type: "delimiter" },
    { path: "/audio-setup", className: "audio-setup", text: "Audio Setup" },
    { type: "delimiter" },
    { path: "/getting-started", className: "audio-setup", text: "Getting Started" },
    // { path: "/faq", className: "faq", text: "FAQ" },
    { path: "/contact", className: "contact", text: "Contact Us" },
  ],
];
const links = [
  { path: "/search?fromMenu=1", className: "find" },
  { path: "/", className: "home" },
  { path: "/welcome", className: "home" },
  { path: "/drawer?position=0", className: "file-cabinet" },
  { path: q("/timeline-basic"), className: "timeline" },
  { path: "/playlists?position=0", className: "playlist" },
  { type: "delimiter" },
  { path: "/news", className: "news" },
  { path: "/movie-night/movietone", className: "pay-per-view-menu" },
  { path: "/movie-night/home", className: "movie-night-image" },
  { type: "delimiter" },
  { path: "/audio-setup", className: "audio-setup" },
  // { path: "/faq", className: "faq" },
  { path: "/contact", className: "contact" },
  { type: "delimiter" },
];

const ignore = (e) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  return false;
};

class GlobalMenu extends Component {
  constructor(props) {
    super(props);

    let hasSigned = localStorage.getItem(
      "nya-user-has-signed-up-for-newsletter"
    );

    this.state = { ready: false, hasSigned, showingPulldown: false };

    this.onClose = this.onClose.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.onBGClick = this.onBGClick.bind(this);
    this.onNewsletterClick = this.onNewsletterClick.bind(this);
  }
  go(path) {
    // Actualizar para usar this.props.history en lugar de router del contexto
    this.props.history.push(path);
    localStorage.removeItem("searchedQuery");
  }
  onNewsletterClick() {
    this.go("/newsletter");
  }
  onClose() {
    this.props.history.goBack();
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.history.goBack();
    }
  }
  onBGClick(e) {
    if (
      !e.target.closest(".user-info") &&
      !e.target.closest(".sharing") &&
      !e.target.closest(".drawer-front-bottom-items") &&
      !e.target.closest(".link")
    ) {
      this.props.history.goBack();
    }
  }
  renderColumnList(column) {
    const {
      freeAlbums,
      freeTracks,
      globalMenuNewUrl = "4",
    } = this.props.commonValues;
    const columnItems = [];

    column.forEach((link, index) => {
      const {
        type,
        text,
        path: pathUrl = false,
        className,
        url = false,
      } = link;
      if (type === "delimiter") {
        columnItems.push(
          <div key={`delimiter-${index}`} className="delimiter" />
        );
      } else {
        let path = _.isFunction(pathUrl) ? link.path() : pathUrl;

        if (path && path.includes("X")) {
          const getId = (tracks) => {
            let track = {};
            Object.keys(tracks).forEach((id) => {
              let key = tracks[id];
              track = key && key.id;
            });
            return track;
          };
          //get album or track id
          let id =
            className === "sod" && freeTracks
              ? getId(freeTracks)
              : getId(freeAlbums) || false;
          if (id) path = path.replace("X", id);
        }

        let cx = cn("link", { [className]: true });

        let click = () => {
          if (url) {
            window.open(url, "_blank");
            return;
          }
          if (path) this.go(path);
        };
        if (className === "playlist") {
          path = "/playlists?position=0";
        }

        if (className === "gifts") {
          path = "/account?screen=gift";
        }

        columnItems.push(
          <div onClick={click} key={path} className={cx}>
            {text}
          </div>
        );
      }
    });
    return <>{columnItems}</>;
  }
  getLinks() {
    const columns = [];
    menuColumns.forEach((column, id) => {
      //TODO - get the column number in the meedle
      let styleName = id === 1 ? "column center" : "column";

      if (id === 2) {
        columns.push(
          <div
            key={id}
            className={hasAuth() ? `${styleName} logged-in` : styleName}
          >
            {this.props.readyToRenderUserInfo && (
              <UserInfo showSubscribe={isFreeUser()} />
            )}
            {this.renderColumnList(column)}
          </div>
        );
      } else {
        columns.push(
          <div
            key={id}
            className={hasAuth() ? `${styleName} logged-in` : styleName}
          >
            {this.renderColumnList(column)}
          </div>
        );
      }
    });
    return <>{columns}</>;
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ ready: true });
    }, 50);
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  renderContent() {
    let { hasSigned } = this.state;
    const orastreamLink =
      process.env.ORASTREAMLINK || "https://store.neilyoungarchives.com";
    let c = String.fromCharCode(169); //copyright symbol
    let releaseVersion = process.env.RELEASE_VERSION;

    return (
      <div className="global-menu" onClick={this.onBGClick} key="global-menu">
        <div className="text-items">{this.getLinks()}</div>
        <div className="drawer-front-bottom-items">
          <div className="items-right">
            <p className="noHighlight">
              <span>{c}</span>{new Date().getFullYear()} Shakey Pictures/
              <span>{c}</span>{new Date().getFullYear()} Warner Records
            </p>
            <span className="pipe">|</span>
            <a target="_blank" onContextMenu={ignore} href={orastreamLink}>
              powered by ORASTREAM
            </a>
            <span className="pipe">|</span>
            <a target="_blank" onContextMenu={ignore} href="/terms.html">
              TERMS AND CONDITIONS
            </a>
            <span className="pipe">|</span>
            <a target="_blank" onContextMenu={ignore} href="/privacy.html">
              PRIVACY POLICY
            </a>
            <span className="pipe">|</span>
            <a
              target="_blank"
              onContextMenu={ignore}
              href="/privacy.html#adchoices"
            >
              AD CHOICES
            </a>
            <span className="pipe">|</span>
            <Link to="/credits">CREDITS</Link>
            {/* <span className="pipe">|</span> */}
            {/* <Link to="/faq">FAQ</Link> */}
            <span className="pipe">|</span>
            <p className="noHighlight">V. {releaseVersion}</p>
          </div>
        </div>
      </div>
    );
  }
  render() {
    let transitionClass = "global-menu-fade-in";
    let { ready } = this.state;

    return (
      <div id="global-menu-wrapper">
        <ReactCSSTransitionGroup
          component="div"
          transitionName={transitionClass}
          transitionEnterTimeout={1000}
          transitionLeaveTimeout={1000}
        >
          {ready ? this.renderContent() : <div key="dummy"></div>}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  console.log("state", state);
  return {
    readyToRenderUserInfo: state.userData,
    playlists: state.playlists,
    commonValues: state.commonValues,
  };
};

export default withRouter(connect(mapStateToProps)(GlobalMenu));
